import { Injectable } from '@angular/core';
import { environment } from '../../../../../../environments/environment';
import { AuthHttp } from '../../../../../services/http/http.service';
import { requestWithResponse } from '../../../../../services/http/request-with-response';

@Injectable()
export class GabineteService {
  public currentGabinete: any;
  public usuariosGabinete: any;
  public gabineteConFiltros: any;
  public currentCategorias: any;
  public existenCambios: boolean;
  public usuario: string;
  toastr: any;

  constructor(private readonly http: AuthHttp) {
    this.currentGabinete = [];
    this.usuariosGabinete = [];
    this.gabineteConFiltros = [];
    this.existenCambios = false;
  }

  listarDatos(tienda_id: string, empresa_id: string) {
    return requestWithResponse(
      this.http.get(`${environment.apiURLs.private}/empresa/${empresa_id}/agenda-gabinetes/listar/${tienda_id}`),
      response => { this.currentGabinete = response; },
      errorResponse => this.toError(errorResponse)
    );
  }

  obtenerUsuariosGabinete(tienda_id: string, empresa_id: string) {
    return requestWithResponse(
      this.http.get(`${environment.apiURLs.private}/empresa/${empresa_id}/agenda-gabinetes/obtener-usuarios/${tienda_id}`),
      response => { this.usuariosGabinete = response; },
      errorResponse => this.toError(errorResponse)
    );
  }

  updateGabinete(gabineteId: string, userId: string, tienda_id: string, empresa_id: string) {
    return requestWithResponse(
      this.http.post(`${environment.apiURLs.private}/empresa/${empresa_id}/agenda-gabinetes/update/${tienda_id}`, { gabineteId, userId }),
      () => undefined,
      errorResponse => this.toError(errorResponse)
    );
  }

  getGabinete(tienda_id: string, empresa_id: string) {
    return requestWithResponse(
      this.http.get(`${environment.apiURLs.private}/empresa/${empresa_id}/agenda-gabinetes/obtener-por-tienda/${tienda_id}`),
      () => undefined,
      errorResponse => this.toError(errorResponse)
    );
  }

  private toError(errorResponse: unknown): Error {
    if (errorResponse instanceof Error) {
      return errorResponse;
    }
    if (typeof errorResponse === 'object' && errorResponse !== null && 'message' in errorResponse) {
      const errorObject = errorResponse as { message: unknown };
      return new Error(String(errorObject.message));
    }
    return new Error(String(errorResponse ?? 'Error en la operación de gabinetes.'));
  }
}
